import React from "react";
import { __ } from "@wordpress/i18n";

const Section = ({
  title,
  titleUnderline,
  className = "",
  tag,
  description,
  children,
  ...delegated
}) => {
  return (
    <div className={`cross-sell-section ${className}`} {...delegated}>
      {(title || tag || description) && (
        <div className="cross-sell-section-header-wrapper">
          {(title || tag) && (
            <div className="cross-sell-section-header">
              {title && (
                <h2 className="cross-sell-text-center">
                  {title}
                  {titleUnderline && (
                    <span className="cross-sell-section-title-underline">
                      {titleUnderline}
                    </span>
                  )}
                </h2>
              )}
              {tag}
            </div>
          )}
          {description && (
            <span className="cross-sell-section-description">
              {description}
            </span>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export { Section };
